import script from "./CaseDetailContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetailContent.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetailContent.vue?vue&type=style&index=0&id=20772db4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20772db4"]])

export default __exports__